import { render, staticRenderFns } from "./visitorPermission.vue?vue&type=template&id=0a339ea8&scoped=true&"
import script from "./visitorPermission.vue?vue&type=script&lang=js&"
export * from "./visitorPermission.vue?vue&type=script&lang=js&"
import style0 from "./visitorPermission.vue?vue&type=style&index=0&id=0a339ea8&prod&lang=css&"
import style1 from "./visitorPermission.vue?vue&type=style&index=1&id=0a339ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a339ea8",
  null
  
)

export default component.exports